import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevrons-down', 'ChevronsDown', [["path",{"d":"M7 7l5 5l5 -5","key":"svg-0"}],["path",{"d":"M7 13l5 5l5 -5","key":"svg-1"}]]);